/**
 * Barrel export for shopify-import utility functions
 *
 * These utilities are extracted from the legacy client ProductForm
 * and adapted for use in the BCC shopify-import feature.
 */

export { imageModifiers, type ImageModifiers } from "./image-modifiers";
export { setUploadImage } from "./set-upload-image";
export { handleLabel } from "./handle-label";
export { handleFilterTranslatedToConfig, type SelectOption, type ProductConfig } from "./handle-filter-translated-to-config";
export { nextSunday } from "./next-sunday";

// Variant-level utilities (Plan 03-03)
export { getBagSizeGroups } from "./get-bag-size-groups";
export type { BagSizeGroup } from "../types";
export { grindsByBagSize } from "./grinds-by-bag-size";
export {
  setVariantChange,
  handleBagSizeChange,
  handleIsProductSelectedForImportChange,
  type HandleChangeValue,
} from "./set-variant-change";
export { setAvailableLocalisedTermOptions } from "./set-available-localised-term-options";

// Business logic utilities (Plan 03-04)
export { handleDisplayVariantDrafts } from "./handle-display-variant-drafts";
export { handleDisplayDraft } from "./handle-display-draft";
export { mapWholeBeanVariants, deriveProductShipTo } from "./map-whole-bean-variants";

// Shared predicates
export { isProductLevelLocked } from "./is-product-level-locked";

// Image resolution
export { resolveProductImage } from "./get-product-image-url";
